var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocketx2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 13.12003,
    height: 11.6,
    viewBox: "0 0 13.12003 11.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath343"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path343"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath345"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path345"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath347"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path347"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath349"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path349"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath351"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path351"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath353"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path353"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath355"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path355"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath357"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path357"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath360"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "rotate(90,4179,1570.5)",
    id: "path360"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath364"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "rotate(90,4179,1570.5)",
    id: "path364"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer-oc2",
    transform: "translate(-132.26667,-356.82667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path342",
    d: "m 2608,5736 v 25 l -3,-25 z m 0,25 -3,-25 v 25 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath343)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path344",
    d: "m 2605,5736 v 25 l -2,-24 z m 0,25 -2,-24 v 23 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path346",
    d: "m 2603,5737 v 23 l -2,-22 z m 0,23 -2,-22 v 21 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path348",
    d: "m 2601,5738 v 21 l -2,-20 z m 0,21 -2,-20 v 19 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path350",
    d: "m 2599,5739 v 19 l -2,-17 z m 0,19 -2,-17 v 15 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path352",
    d: "m 2597,5741 v 15 l -1,-13 z m 0,15 -1,-13 v 11 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path354",
    d: "m 2596,5743 v 11 l -1,-9 z m 0,11 -1,-9 v 7 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path356",
    d: "m 2595,5745 v 7 -5 z m 0,7 v -5 3 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path358",
    d: "m 2608,5786 v -75",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path359",
    d: "m -37.5,0 c 0,-20.71068 16.78932,-37.5 37.5,-37.5 20.71068,0 37.5,16.78932 37.5,37.5",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.16,0,0,-0.16,138.74667,357.30667)",
    clipPath: "url(#clipPath360)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path361",
    d: "m 2595,5749 h -34 v -21",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path362",
    d: "m 2561,5749 v 20",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path363",
    d: "m -12.5,0 c 0,-6.90356 5.59644,-12.5 12.5,-12.5 6.90356,0 12.5,5.59644 12.5,12.5",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.16,0,0,-0.16,138.74667,357.30667)",
    clipPath: "url(#clipPath364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path365",
    d: "m 2561,5759 h -19",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path366",
    d: "m 2561,5738 h -19",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocketx2);
export default __webpack_public_path__ + "static/media/socketx2.65a60b5186f98b49f559efcf9ffa6a79.svg";
export { ForwardRef as ReactComponent };